import styled from "styled-components";

export const StyledSvgLogo = styled.button`
  background-color: rgba(52, 52, 52, 0.8);
  color: none;
  padding: 10px;
  border: 3px solid var(--white);
  cursor: pointer;
  
  :hover{
    height: 55px;
    width: 55px;
  }
`;

export const StyledSvgLogoSmall = styled.button`
  background-color: rgba(52, 52, 52, 0.8);
  color: none;
  padding: 10px;
  border: 3px solid var(--white);
  cursor: pointer;
`;

// Used for wrapping a page component
export const Screen = styled.div`
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--bg);
  justify-content: center;
  align-items: center;
  padding: 24px;
`;

// Used for wrapping a page component
export const ScreenSmall = styled.div`
  background-color: var(--bg-gray);
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
  width: 100%;
  display: flex;
  nin-height: 30vh;
  flex-direction: column;
`;

// Used for wrapping a page component
export const ScreenFull = styled.div`
  justify-content: "${({ jc }) => (jc ? jc : "center")}";
  align-items: "${({ ai }) => (ai ? ai : "center")}";
  // padding: 48px;
  width: 100%;
  min-height: 100vh;
  z-index: 0;
  @media (max-width: 1440px) {
    display: none;
  };
  display: flex;

  // background-color: var(--bg);
  // background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  // background-size: cover;
  // background-position: center;
  // display: flex;
  // flex-direction: column;
  // justify-content: ${({ jc }) => (jc ? jc : "center")};
  // align-items: "${({ ai }) => (ai ? ai : "center")}";
  // @media (max-width: 769px) {
  //   padding: 12px;
  // }
  // @media (min-width: 770px) {
  //   // padding-top: 70px;
  //   // padding-bottom: 70px;
  //   // min-height: 100vh;
  //   // max-height: 100vh;
  // }
`;

// Used for wrapping a page component
export const Footer = styled.div`
  background-color: var(--primary);
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ImageWrapper = styled.img`
  background-color: var(--bg);
  height:  ${({ height }) => (height ? height : "auto")};
  width:   ${({ width }) => (width ? width : "150%")};
  transition: width 0.5s;
  margin-bottom: 6px;
  @media (min-width: 1px) {
    display: none;
  };
  @media (min-width: 780px) {
    display: none;
  };
  @media (min-width: 900px) {
    display: none;
  };
  @media (min-width: 1280px) {
    display: inline;
  };
  @media (min-width: 2000px) {
    display: inline;
  };
`;

export const TimerWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

// Used for providing space between components
export const HorizontalRule = styled.hr`
  color: var(--off-white);
`;

// Used for providing space between components
export const SpacerXSmall = styled.div`
  height: 8px;
  width: 8px;
`;

// Used for providing space between components
export const SpacerSmall = styled.div`
  height: 16px;
  width: 16px;
`;

// Used for providing space between components
export const SpacerMedium = styled.div`
  height: 24px;
  width: 24px;
`;

// Used for providing space between components
export const SpacerLarge = styled.div`
  height: 32px;
  width: 32px;
`;

// Used for providing space between components
export const SpacerHorizontal = styled.div`
  width: 16px;
`;

// Used for providing space between components
export const SpacerHorizontalLarge = styled.div`
  width: 128px;
`;

// Used for providing space between components
export const SpacerHorizontalXLarge = styled.div`
  width: 128;
  @media (max-width: 768px) {
    display: none;
  }
`;

// Used for providing space between components
export const SpacerHorizontalXXLarge = styled.div`
  width: 256;
  @media (max-width: 768px) {
    display: none;
  }
`;

// Used for providing space between components
export const BackgroundVideo = styled.video`
  justify-content: ${({ jc }) => (jc ? jc : "start")};
  align-items: "${({ ai }) => (ai ? ai : "start")}";
  width: 100%;
  min-height: 100vh;
  z-index: 0;
  position: absolute;
  @media (max-width: 1440px) {
    display: none;
  };
`;

// Used for providing a wrapper around a component
export const LandingZoneContainer = styled.div`
  display: flex;
  flex: ${({ flex }) => (flex ? flex : 0)};
  flex-direction: ${({ fd }) => (fd ? fd : "column")};
  background-color: var(--bg-gray);
  min-height: 120vh;
  max-height: 120vh;
  width: 100%;
  height: fit-content;
  @media (max-width: 768px) {
    background-image: ${`url(/config/images/clokies_background.jpg)`};
    justify-content: ${({ jc }) => (jc ? jc : "flex-end")};
    align-items: "${({ ai }) => (ai ? ai : "center")}";
    padding-bottom: 90px;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 24px;
    min-height: 100vh;
    max-height: 100vh;
  };
  @media (min-width: 769px) {
    // background-image: ${`url(/config/images/clokies_background.jpg)`};
    justify-content: ${({ jc }) => (jc ? jc : "end")};
    align-items: ${({ ai }) => (ai ? ai : "center")};
    padding: 18px;
    padding-bottom: 70px;
  };
  @media (max-width: 1440px) {
    background-image: ${`url(/config/images/clokies_background.jpg)`};
    justify-content: ${({ jc }) => (jc ? jc : "end")};
    align-items: ${({ ai }) => (ai ? ai : "center")};
    padding: 18px;
  };
  background-size: cover;
  background-position: center;
`;

// Used for providing a wrapper around a component
export const AboutSectionContainer = styled.div`
  display: flex;
  flex: ${({ flex }) => (flex ? flex : 0)};
  flex-direction: ${({ fd }) => (fd ? fd : "column")};
  justify-content: ${({ jc }) => (jc ? jc : "flex-start")};
  align-items: ${({ ai }) => (ai ? ai : "flex-start")};
  background-color: ${({ test }) => (test ? "pink" : "none")};
  width: 100%;
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 36px;
  padding-right: 100px;

  @media (max-width: 768px) {
    padding-left: 12px;
    padding-right: 12px;
    align-items: start;
  };
  @media (max-width: 1100px) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const AboutClokiesWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: stretched;
  align-items: center;
  width: 100%;
  // padding-left: 200px;
  // padding-right: 200px;
  @media (max-width: 768px) {
    padding-left: 0px;
    padding-right: 0px;
    flex-direction: column;
  }
`;

// Used for providing a wrapper around a component
export const MinterContainer = styled.div`
  display: flex;
  flex: ${({ flex }) => (flex ? flex : 0)};
  flex-direction: ${({ fd }) => (fd ? fd : "column")};
  justify-content: ${({ jc }) => (jc ? jc : "flex-end")};
  align-items: ${({ ai }) => (ai ? ai : "center")};
  background-color: ${({ test }) => (test ? "pink" : "none")};
  height: fit-content;
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
  // margin-bottom:5%;
`;

// Used for providing a wrapper around a component
export const MinterDeviceImage = styled.img`
  width: 40%;
  justify-content: ${({ jc }) => (jc ? jc : "end")};
  align-items: ${({ ai }) => (ai ? ai : "center")};
  @media (max-width: 768px) {
    width:100%;
  };
`;

// Used for providing a wrapper around a component
export const LogoImage = styled.img`
  justify-content: ${({ jc }) => (jc ? jc : "end")};
  align-items: ${({ ai }) => (ai ? ai : "center")};
  @media (max-width: 768px) {
    width:100%;
  };
`;

// Used for providing a wrapper around a component
export const AboutImage = styled.img`
  justify-content: ${({ jc }) => (jc ? jc : "end")};
  align-items: ${({ ai }) => (ai ? ai : "center")};
  width: 100%;
  @media (max-width: 768px) {
    width:100%;
  };
`;

// Used for providing a wrapper around a component
export const MinterButtonParent = styled.div`
  position: absolute;
  display: flex;
  flex: ${({ flex }) => (flex ? flex : 0)};
  flex-direction: ${({ fd }) => (fd ? fd : "row")};
  justify-content: ${({ jc }) => (jc ? jc : "flex-end")};
  align-items: ${({ ai }) => (ai ? ai : "center")};
  background-color: ${({ test }) => (test ? "pink" : "none")};
  width: 22%;
  height: 17%;
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
  margin-left: 240px;
  margin-bottom: 30px;
`;

export const MinterConnectButton = styled.img`
  width: 40%;
  height: auto;
  cursor: pointer;
  content: url("/config/images/unpressedConnect.png");
  :hover{
    content: url("/config/images/pressedConnect.png");
  }
`;

export const MinterMintButton = styled.img`
  width: 28%;
  height: auto;
  cursor: pointer;
  content: url("/config/images/unpressedMint.png");
  :hover{
    content: url("/config/images/pressedMint.png");
  }
`;

// Used for providing a wrapper around a component
export const Container = styled.div`
  display: flex;
  flex: ${({ flex }) => (flex ? flex : 0)};
  flex-direction: ${({ fd }) => (fd ? fd : "column")};
  justify-content: ${({ jc }) => (jc ? jc : "flex-center")};
  align-items: ${({ ai }) => (ai ? ai : "flex-start")};
  background-color: ${({ test }) => (test ? "bg" : "none")};
  width: 100%;
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
  z-index: 2;
`;

// Used for providing a wrapper around a component
export const TeamContainer = styled.div`
  display: flex;
  flex: ${({ flex }) => (flex ? flex : 0)};
  flex-direction: ${({ fd }) => (fd ? fd : "column")};
  justify-content: ${({ jc }) => (jc ? jc : "flex-start")};
  align-items: ${({ ai }) => (ai ? ai : "flex-start")};
  background-color: ${({ test }) => (test ? "pink" : "none")};
  width: 100%;
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
  z-index: 2;
  overflow-x: scroll;
  white-space: nowrap;
  @media (max-width: 768px) {

    justify-content: flex-start;
    align-items: flex-start;
  }
`;

// Used for providing a wrapper around a component
export const LinksContainer = styled.div`
  display: flex;
  flex: ${({ flex }) => (flex ? flex : 0)};
  flex-direction: ${({ fd }) => (fd ? fd : "row")};
  justify-content: ${({ jc }) => (jc ? jc : "flex-end")};
  align-items: ${({ ai }) => (ai ? ai : "flex-start")};
  background-color: ${({ test }) => (test ? "pink" : "none")};
  width: 100%;
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
  z-index: 1;
  @media (max-width: 1100px) {
    flex-direction: ${({ fd }) => (fd ? fd : "row")};
    justify-content: ${({ jc }) => (jc ? jc : "center")};
    align-items: ${({ jc }) => (jc ? jc : "flex-end")};
  }
  @media (min-width: 1101px) {
    padding-bottom: 150px;
  }
`;


// Used for providing a wrapper around a component
export const MintDetailsContainer = styled.div`
  display: flex;
  flex: ${({ flex }) => (flex ? flex : 0)};
  flex-direction: ${({ fd }) => (fd ? fd : "column")};
  justify-content: ${({ jc }) => (jc ? jc : "flex-start")};
  align-items: ${({ ai }) => (ai ? ai : "flex-start")};
  background-color: ${({ test }) => (test ? "pink" : "none")};
  width: 100%;
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  @media (max-width: 780px) {
    max-width: 750px;
  };
  @media (max-width: 1280px) {
    max-width: 750px;
  };
`;

export const TextCounter = styled.p`
  color: var(--white);
  text-align: left;
  font-size: 22px;
  font-weight: 500;
  line-height: 1.6;
  text-align: center;
  padding: 4px;
  @media (min-width: 780px) {
    font-size: 24px;
  };
  @media (min-width: 900px) {
    font-size: 28px;
  };
  @media (min-width: 1281px) {
    font-size: 30px;
  };
  @media (min-width: 2000px) {
    font-size: 32px;
  };
`;

export const TextTitle = styled.p`
  color: var(--primary-text);
  font-size: 10px;
  font-weight: 500;
  line-height: 1.6;
  text-align: center;
  @media (max-width: 780px) {
    font-size: 8px;
  };
  @media (max-width: 1280px) {
    font-size: 10px;
  };
  @media (min-width: 1281px) {
    font-size: 12px;
  };
`;

export const TextSubTitle = styled.p`
  font-size: 12px;
  font-weight: 500;
  color: var(--white);
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  @media (min-width: 780px) {
    font-size: 12px;
  };
  @media (min-width: 900px) {
    font-size: 14px;
  };
  @media (min-width: 1281px) {
    font-size: 14px;
  };
  @media (min-width: 2000px) {
    font-size: 14px;
  };
`;

export const TextDescription = styled.p`
  color: var(--bg);
  font-size: 10px;
  line-height: 1.6;
  text-align: left;
  @media (max-width: 768px) {
    font-size: 10px;
    text-align: center;
  }
  @media (min-width: 1080px) {
    font-size: 14px;
  };
`;



export const TextParagraph = styled.p`
  color: var(--black);
  font-size: 22px;
  line-height: 1.6;
  text-align: left;
  @media (max-width: 768px) {
    font-size: 18px;
    text-align: center;
  }
  @media (max-width: 1280px) {
    font-size: 14px;
    text-align: left;
  }
  font-family: "Open Sans", sans-serif;
`;

export const TextFooter = styled.p`
  color: var(--accent-text);
  font-size: 16px;
  line-height: 1.6;
`;

export const StyledClickable = styled.div`
  :active {
    opacity: 0.6;
  }
`;

export const TeamSection = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`;
